import { FeatureFlagsState } from 'app/shared/featureFlags/models';

export const UNLOADED_FLAGS_KEY = 'LAUNCH_DARKLY_FLAGS_UNLOADED';

export const initialState: Readonly<FeatureFlagsState> = {
  flags: {
    [UNLOADED_FLAGS_KEY]: true,
  },
};
